var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home-banner"},[_c('img',{attrs:{"src":_vm.pictureUrl,"alt":"","srcset":""},on:{"click":_vm.See}})]),_c('div',{staticClass:"home-content clearfix"},_vm._l((_vm.pageConfigList),function(item,index){return _c('div',{key:index,staticClass:"home-content-list",on:{"click":function($event){return _vm.handleGoPage(item.name)}}},[_c('img',{attrs:{"src":item.name == '问题报修'
            ? _vm.icon1
            : item.name == '业务咨询'
            ? _vm.icon2
            : item.name == '常见问题'
            ? _vm.icon3
            : item.name == '产品充值'
            ? _vm.icon4
            : item.name == '人员核实'
            ? _vm.icon5
            : item.name == '用户信息'
            ? _vm.icon6
            : item.name == '人员培训'
            ? _vm.icon7
            : item.name == '人员考核'
            ? _vm.icon8
            : item.name == '网吧管理'
            ? _vm.icon9
            : item.name == '工单处理'
            ? _vm.icon10
            : item.name == '巡检工作'
            ? _vm.icon11
            : item.name == '知识库'
            ? _vm.icon12
            : item.name == '客户管理'
            ? _vm.icon13
            : item.name == '抽奖活动'
            ? _vm.icon14
            : item.name == '我的积分'
            ? _vm.icon15
            : '',"alt":"","srcset":""}}),_c('div',{staticClass:"home-content-list-text"},[_vm._v(_vm._s(item.name))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }